import React from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faCheck, faTimes, faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { toast } from "sonner";

export const DropdownItemWithActions = ({
    icon,
    title,
    onClickMain,
    itemId,
    isEditing,
    setEditingFilterId,
    onEdit,
    onDelete,
    onUpdate,
    setEditValue,
    editValue,
    canEdit_canDownload
}) => {

    const handleEditClick = (e) => {
        if (!canEdit_canDownload) {
            toast.warning("You are not a shared pipeline user. You are not authorized for this action!")
            return;
        }
        e.preventDefault();
        setEditValue(title);
        // setIsEditing(true);
        setEditingFilterId(itemId)
        if (onEdit) onEdit();
    };

    const handleCancel = () => {
        setEditValue(title);
        // setIsEditing(false);
        setEditingFilterId(null)
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onUpdate();
        } else if (e.key === 'Escape') {
            handleCancel();
        }
    };

    // --- EDIT MODE UI ---
    if (isEditing) {
        return (
            <div className="d-flex align-items-center justify-content-between px-3 py-2 bg-light rounded-2 mx-2 my-1 border">
                <div className="d-flex align-items-center flex-grow-1">
                    <FontAwesomeIcon
                        icon={icon}
                        className="text-muted me-2"
                        style={{ width: "12px", height: "12px" }}
                    />
                    <input
                        type="text"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                        onKeyDown={handleKeyPress}
                        className="form-control form-control-sm border-primary-subtle"
                        style={{
                            fontSize: "13px",
                            height: "28px",
                            padding: "2px 8px",
                            boxShadow: "none"
                        }}
                        autoFocus
                    />
                </div>
                <div className="d-flex align-items-center ms-2 gap-1">
                    <button
                        type="button"
                        className="btn btn-sm d-flex align-items-center justify-content-center"
                        onClick={onUpdate}
                        style={{
                            backgroundColor: "#7a3a5e",
                            color: "white",
                            width: "26px",
                            height: "26px",
                            padding: "0",
                            borderRadius: "4px"
                        }}
                    >
                        <FontAwesomeIcon icon={faCheck} style={{ fontSize: "10px" }} />
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-light border d-flex align-items-center justify-content-center"
                        onClick={handleCancel}
                        style={{
                            width: "26px",
                            height: "26px",
                            padding: "0",
                            borderRadius: "4px"
                        }}
                    >
                        <FontAwesomeIcon icon={faTimes} className="text-muted" style={{ fontSize: "10px" }} />
                    </button>
                </div>
            </div>
        );
    }

    // --- VIEW MODE UI ---
    return (
        <div
            className="d-flex align-items-center justify-content-between px-3 py-2 custom-dropdown-item"
            style={{ transition: 'background 0.2s ease' }}
            onClick={(e) => e.stopPropagation()}
        >
            <style jsx>{`
                .custom-dropdown-item:hover {
                    background-color: rgba(122, 58, 94, 0.04);
                }
                .action-trigger:hover {
                    color: #7a3a5e !important;
                    background-color: rgba(122, 58, 94, 0.1);
                }
            `}</style>

            <a
                href="#"
                className="d-flex align-items-center text-decoration-none text-dark flex-grow-1"
                onClick={onClickMain}
                style={{ fontSize: '13px', fontWeight: '500', textTransform: "capitalize" }}
            >
                <div
                    className="d-flex align-items-center justify-content-center rounded me-2 "
                    style={{
                        width: '24px',
                        height: '24px',
                        backgroundColor: '#f1f5f9',
                        color: '#64748b'
                    }}
                >
                    <FontAwesomeIcon icon={icon} style={{ width: "11px", height: "11px" }} />
                </div>
                {title}
            </a>

            <Dropdown>
                <Dropdown.Toggle
                    as="div"
                    className="action-trigger d-flex align-items-center justify-content-center rounded-circle cursor-pointer text-muted no-arrow"
                    style={{ width: "24px", height: "24px", transition: 'all 0.2s' }}
                >
                    <FontAwesomeIcon icon={faEllipsisV} style={{ fontSize: '12px' }} />
                </Dropdown.Toggle>

                <Dropdown.Menu
                    align="end"
                    className="border-0 shadow-sm py-2"
                    style={{ borderRadius: '8px', minWidth: '120px' }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <Dropdown.Item
                        className="d-flex align-items-center gap-2 py-2"
                        style={{ fontSize: '13px' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleEditClick(e);
                        }}
                    >
                        <FontAwesomeIcon icon={faPencilAlt} className="text-muted" style={{ width: '12px' }} />
                        Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                        className="d-flex align-items-center gap-2 py-2 text-danger"
                        style={{ fontSize: '13px' }}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onDelete();
                        }}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} style={{ width: '12px' }} />
                        Delete
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};